import ChatInterface from '../components/chat/ChatInterface'

export default function HomePage() {
  return <ChatInterface />
}
